import React, { useEffect, useState, useRef } from 'react';
import { Form, Input, Button, Spin, Alert, Card } from 'antd';
import api from '../../services/api';

const HomeManagement = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
    const formRef = useRef(null);
  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const { data } = await api.get('/pages/home');
        form.setFieldsValue(data);
        setLoading(false);
      } catch (err) {
        setErrorMsg('Failed to load home page data');
        setLoading(false);
      }
    };
    fetchHomeData();
  }, [form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await api.put('/pages/home', values);
      setSuccessMsg('Home page updated successfully');
      setTimeout(() => setSuccessMsg(''), 3000);
              // Scroll to form top
  formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      setErrorMsg(err.response?.data?.message || 'Failed to update home page');
    }
  };

  if (loading) {
    return <Spin size="large" />;
  }

  return (
      <div ref={formRef}>
    <Card title="Home Page Management" bordered={false}>
      {successMsg && <Alert message={successMsg} type="success" showIcon closable />}
      {errorMsg && <Alert message={errorMsg} type="error" showIcon closable />}

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Home Title"
          name="home_title"
          rules={[{ required: true, message: 'Please enter home title' }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        <Form.Item
          label="Home About"
          name="home_about"
          rules={[{ required: true, message: 'Please enter home about' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Initial Concept"
          name="home_initial_concept"
          rules={[{ required: true, message: 'Please enter initial concept' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Market Analysis"
          name="home_market_analysis"
          rules={[{ required: true, message: 'Please enter market analysis' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Grow Business"
          name="home_grow_business"
          rules={[{ required: true, message: 'Please enter grow business content' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Fast Support"
          name="home_fast_support"
          rules={[{ required: true, message: 'Please enter fast support content' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>


            <Form.Item
          label="Improve Your Business With Us : Content"
          name="home_cta_section"
          rules={[{ required: true, message: 'Please enter content for cta section' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>


            <Form.Item
          label="Improve Your Business With Us : Contact Number"
          name="home_cta_mobile_number"
          rules={[{ required: true, message: 'Please enter mobile number' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>




        <Form.Item
          label="Valuable Ideas"
          name="home_valuable_ideas"
          rules={[{ required: true, message: 'Please enter valuable ideas' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Industry Experience"
          name="home_industry_experience"
          rules={[{ required: true, message: 'Please enter industry experience' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

          <Form.Item
          label="Budget Friendly"
          name="budget_friendly"
          rules={[{ required: true, message: 'Please enter Budget friendly' }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Update Home Page
          </Button>
        </Form.Item>
      </Form>
    </Card>
    </div>
  );
};

export default HomeManagement;